/**
 * URL display and formatting configuration constants
 */

/** Maximum character length for URL truncation in display */
export const URL_TRUNCATE_LENGTH = 50;

/** Maximum character length for title truncation in display */
export const TITLE_TRUNCATE_LENGTH = 50;
